<template>
  <button
    v-bind="$attrs"
    :aria-label="ariaLabel || text"
    :data-qa="dataQa"
    :disabled="disabled"
    class="base-link"
    type="button"
    @click="handleClick"
  >
    <span class="base-link__text">
      <span
        v-if="hasSlot.icon"
        class="base-link__icon"
        aria-hidden="true"
      >
        <slot name="icon" />
      </span>
      {{ text }}
    </span>
  </button>
</template>

<script setup>
import useVueSlots from '@shared/composables/useVueSlots.js'

defineOptions({
  inheritAttrs: false,
})

const emit = defineEmits(['click'])
const { hasSlot } = useVueSlots(['icon'])

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  ariaLabel: {
    type: String,
    default: '',
  },
  dataQa: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const handleClick = (event) => {
  if (props.disabled) return
  emit('click', event)
}
</script>

<style lang="scss" scoped>
.base-link {
  @include kds-typography-interactive-medium();
  width: fit-content;
  margin: -$kds-space-1x;
  padding: $kds-space-1x;
  border: 0;
  border-radius: $kds-space-1x;
  background: transparent;
  color: $kds-color-text-interactive-accent;
  cursor: pointer;
  text-align: left;
  transition: transform 0.1s ease-out;
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: 3px solid $kds-color-line-focus;
  }

  &:disabled {
    color: $kds-color-text-on-interactive-disabled;
    cursor: not-allowed;
  }

  &:not(:disabled):active,
  &:not(:disabled):focus-visible:active {
    transform: scale(0.98);
  }

  &__icon {
    display: inline-block;
    line-height: 1;
    margin-right: $kds-space-0_5x;
    vertical-align: -0.4em;
  }

  &__text {
    display: inline;
    color: inherit;
  }
}

@media (prefers-reduced-motion: reduce) {
  .base-link:not(:disabled):active,
  .base-link:not(:disabled):focus-visible:active {
    transform: none;
  }
}
</style>
